import { FormattedMessage } from 'react-intl';
import type { Header } from '../types/table';

export const processTableFilterOptions = (
  options: string[],
  formattedMessages?: Object,
  { showCounts = true }: { showCounts?: boolean } = {},
) => {
  // Remove duplicates, sort, and map to label/value objects
  Object.keys(options).forEach((key) => {
    // count the number of times each value appears
    const counts = {};
    options[key].forEach((value) => {
      counts[value] = (counts[value] || 0) + 1;
    });
    options[key] = Array.from(new Set(options[key]))
      .sort()
      .map((value) => {
        const hasFormattedMessages =
          formattedMessages && formattedMessages[value];
        return {
          text: hasFormattedMessages ? (
            <FormattedMessage
              {...formattedMessages[value]}
              values={{ count: counts[value] }}
            />
          ) : showCounts ? (
            `${value} (${counts[value]})`
          ) : (
            String(value)
          ),
          value: value?.toLowerCase(),
        };
      });
  });
};

export const adaptHeaders = (headers: Header[], context: Object) => {
  headers.forEach((header) => {
    if (header.filterOptions) {
      // Adapt the filtering to set options based on enabled function
      header.filterOptions = header.filterOptions.filter((o) =>
        o.enabled ? o.enabled(context) : true,
      );
    }
  });
};
